import { render, staticRenderFns } from "./GoBroadToGoNarrow16.vue?vue&type=template&id=6aaa8ef8&"
import script from "./GoBroadToGoNarrow16.vue?vue&type=script&lang=js&"
export * from "./GoBroadToGoNarrow16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports